<template>
  <div class="flex gap-2 items-center">
    <!-- Нижняя граница (для range) -->
    <input
      v-if="toleranceType === 'range'"
      type="number"
      step="any"
      :value="toleranceFrom"
      @input="$emit('update:toleranceFrom', $event.target.value ? Number($event.target.value) : null)"
      placeholder="От"
      class="w-20 px-2 py-1.5 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
    />

    <!-- Селект типа допуска -->
    <select
      :value="toleranceType"
      @change="onTypeChange($event.target.value)"
      class="px-2 py-1.5 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
    >
      <option :value="null" value="">—</option>
      <option value="range">Интервал (±)</option>
      <option value="min">Не менее</option>
      <option value="max">Не более</option>
    </select>

    <!-- Значение (to для range, единственное для min/max) -->
    <input
      v-if="toleranceType"
      type="number"
      step="any"
      :value="toleranceType === 'min' ? toleranceFrom : toleranceTo"
      @input="onValueInput($event.target.value)"
      :placeholder="toleranceType === 'range' ? 'До' : 'Значение'"
      class="w-20 px-2 py-1.5 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
    />
  </div>
</template>

<script>
export default {
  name: 'ToleranceInput',
  props: {
    toleranceType: { type: String, default: null },
    toleranceFrom: { type: Number, default: null },
    toleranceTo: { type: Number, default: null },
  },
  emits: ['update:toleranceType', 'update:toleranceFrom', 'update:toleranceTo'],
  methods: {
    onTypeChange(type) {
      const val = type || null;
      this.$emit('update:toleranceType', val);
      if (val === 'min') {
        this.$emit('update:toleranceTo', null);
      } else if (val === 'max') {
        this.$emit('update:toleranceFrom', null);
      } else if (!val) {
        this.$emit('update:toleranceFrom', null);
        this.$emit('update:toleranceTo', null);
      }
    },
    onValueInput(raw) {
      const val = raw ? Number(raw) : null;
      if (this.toleranceType === 'min') {
        this.$emit('update:toleranceFrom', val);
      } else {
        this.$emit('update:toleranceTo', val);
      }
    },
  },
};
</script>
